const getEnv = (key: string, value?: string): string => {
  if (!value) {
    throw new Error(`Missing environment variable: ${key}`);
  }
  return value;
};

export const CONFIG = {
  apiUrlMain: getEnv("REACT_APP_API_URL_MAIN", process.env.REACT_APP_API_URL_MAIN),
  apiUrlSecondary: getEnv("REACT_APP_API_URL_SECONDARY", process.env.REACT_APP_API_URL_SECONDARY),
  appEnv: process.env.REACT_APP_ENV || "development",
};